import * as React from "react";
export class PaletteCanvas extends React.PureComponent {
    constructor(props) {
        super(props);
        this.drawRamp = (color, canv, n = this.props.width) => {
            const height = this.props.height;
            const width = n;
            const margin = this.props.margin !== undefined ? `${this.props.margin}px` : "";
            const border = this.props.useBorder ? "1px solid #000000" : "";
            const canvas = canv;
            let context = canvas.getContext("2d");
            canvas.height = height;
            canvas.width = width;
            canvas.style.margin = margin;
            canvas.style.height = `${height}px`;
            canvas.style.imageRendering = "-moz-crisp-edges";
            canvas.style.imageRendering = "pixelated";
            canvas.style.border = border;
            for (let i = 0; i < n; i++) {
                context.fillStyle = color(i / (width - 1));
                context.fillRect(i, 0, 1, height);
            }
        };
        this.mainCanvasRef = React.createRef();
    }
    componentDidMount() {
        if (this.mainCanvasRef !== null || this.mainCanvasRef !== undefined) {
            this.drawRamp(this.props.color, this.mainCanvasRef.current);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.color !== this.props.color) {
            this.drawRamp(this.props.color, this.mainCanvasRef.current);
        }
    }
    render() {
        return React.createElement("canvas", { ref: this.mainCanvasRef });
    }
}
//# sourceMappingURL=PaletteCanvas.js.map